module.exports = __webpack_public_path__ + "src/assets/img/stop.a5fdff65.svg";